<template>
    <div class="bookmark">
        <b-img src="/images/webinars/bookmark.svg" class="bookmark-icon"/>
    </div>
</template>

<script>
export default {
    name: "Bookmark"
}
</script>

<style scoped lang="scss">
    .bookmark {
        position: absolute;
        top: 0;
        right: 1.5rem;

        &-icon{
            width: 25px;
        }
    }

    @media(max-width: 768px) {
        .bookmark {
            right: 1rem;

            &-icon{
                width: 18px;
            }
        }
    }
</style>